import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/faqs';
import { siteInfo } from '@/mocks/site';
import FaqAccordion from '@/components/feature/FaqAccordion';

export default function FaqSection() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            FAQ
          </span>
          <h2 className="mt-2.5 font-heading text-2xl tracking-wide text-foreground-950 md:text-[32px]">
            关于瓜圈速报，你可能想问
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            从热度算法到内容原则，我们把被问得最多的几个问题整理在这里。还有别的疑问，欢迎来信。
          </p>
          <a
            href={`mailto:${siteInfo.email}`}
            rel="nofollow"
            className="mt-6 inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-mail-line" />
            写信给编辑部
          </a>
        </div>

        <div className="lg:col-span-8">
          <FaqAccordion items={faqs} />
        </div>
      </div>
    </section>
  );
}